import styled from "styled-components";

export const FormContainer = styled.div`
    width: 100%;
    max-width: 50em;
`

export const FormEntry = styled.div`
    width: 100%;
    max-width: 50em;

    margin: 1em 0 1em 0;
`

export const FormLabel = styled.p`
    
`

export const FormInput = styled.input`
    width: 100%;
    height: 2.5em;
`

export const FormError = styled.p`
    
`

export const FormSelect = styled.select`
    width: 100%;
    height: 2.5em;
`

export const FormButton = styled.button`
    width: 100%;
    height: 2.5em;
`